<div>
  {{''| i18n:errorMessage}}
</div>
